import React from 'react';
import ReactDOM from 'react-dom';
import { compose, withState, lifecycle, renderNothing } from 'recompose';

export const enhance = compose(
	withState('infoWindow', 'setInfoWindow', null),
	lifecycle({
		componentDidMount() {
			const { content, google, map, setInfoWindow, location, onClose } =
				this.props;
			if (google && map) {
				const infoContent = document.createElement('div');
				ReactDOM.render(<div>{content}</div>, infoContent);

				const infoWindow = new google.maps.InfoWindow({
					content: infoContent,
					pixelOffset: new google.maps.Size(0, -26),
					position: new google.maps.LatLng(
						location.latitude,
						location.longitude,
					),
				});

				google.maps.event.addListener(
					infoWindow,
					'closeclick',
					onClose,
				);

				setInfoWindow(infoWindow);

				infoWindow.open(map);
			}
		},
		componentWillUnmount() {
			const { google, infoWindow, setInfoWindow } = this.props;
			if (infoWindow) {
				infoWindow.close();
				google.maps.event.clearInstanceListeners(infoWindow);
				setInfoWindow(null);
			}
		},
	}),
);

export default enhance(renderNothing());
